import type { OptionType } from "../../../../../../types/types";

export {
  DownloadTemplateContainer,
  RegularTextBlock,
  TemplateButtonContainer,
  DocumentDownloadContainer,
  convertArrayBufferToZipUrl,
} from "../../../../../../components/DownloadTemplateFiles/DownloadTemplateFiles";

// PIM products land in one of these statuses on upload; only these are
// valid for CSV export, so both the picker list and the export request are
// restricted to them.
export const DEFAULT_STATUSES = [
  "published",
  "unpublished",
  "draft",
  "staged",
  "unpublished_staged",
];

export type UploadStages = "table" | "download" | "upload";

export type UploadState = {
  uploadStage: UploadStages;
  selectedTemplate?: OptionType<string>;
  showConfirmTemplateSelectionButton: boolean;
  collectionFileNames: Record<string, string>;
  selected_products?: string[] | "all";
  export_id?: string;
};

export type UploadAction = {
  type:
    | "select_template"
    | "comfirm_template"
    | "set_export_id"
    | "set_selected_products"
    | "continue_from_download"
    | "discard_template"
    | "move_back"
    | "complete";
  payload: UploadState;
};

export type AsyncTableType = {
  id: string;
  externalId: string;
  name: string;
  chemical_name: string;
};
